import template from './svg-logo.template';
import localization from './svg-logo.localization';

class SVGLogo extends HTMLElement {
  static localizationData = localization;

  static htmlTemplate = template;

  constructor() {
    super();

    // Attach Shadow DOM
    const shadow = this.attachShadow({ mode: 'open' });

    this.localize = this.localize.bind(this);

    // Clone the template content into the Shadow DOM
    const svgLogoTemplate = document.createElement('template');
    svgLogoTemplate.innerHTML = SVGLogo.htmlTemplate;
    shadow.append(svgLogoTemplate.content.cloneNode(true));

    if (this.dataset.homeRef) {
      this.shadowRoot.querySelector('a').href = this.dataset.homeRef;
    }

    this.localize();
  }

  localize() {
    // read the language attribute if not present use the browser language
    const language = (this.lang ? this.lang : navigator.language).slice(0, 2).toLowerCase();
    // Set localized content
    if (Object.keys(SVGLogo.localizationData).includes(language)) {
      const localizedData = SVGLogo.localizationData[language];
      this.shadowRoot.querySelector('img').alt = localizedData.altText;
      this.shadowRoot.querySelector('a').title = localizedData.titleText;
      this.lang = language;
    } else {
      this.removeAttribute('lang');
    }
  }
}

export default SVGLogo;
